import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import {NgbDate, NgbDateStruct, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { BookingService } from '../../../shared/services/booking.service';
import { HolidayPrefetchService } from '../../../shared/services/holiday-prefetch.service';
import { MobileService } from '../../../shared/services/mobile.service';
import { ModalStatusService } from '../../../shared/services/modal-status.service';
import { IDestinationBoxElement } from '../../interfaces/idestination-box-element';
import { IEngineParamChange } from '../../interfaces/iengine-param-change';
import { EngineHolidayModalDatepickerComponent } from '../engine-holiday-modal-datepicker/engine-holiday-modal-datepicker.component';
import { EngineTabTypes } from './../../models/engine-tab-types.enum';

@Component({
  selector: 'app-engine-holiday-control-datepicker',
  templateUrl: './engine-holiday-control-datepicker.component.html',
  styleUrls: ['./engine-holiday-control-datepicker.component.scss']
})
export class EngineHolidayControlDatepickerComponent implements OnInit, OnChanges, OnDestroy {

  @Input() selectedDestination: IEngineParamChange<IDestinationBoxElement>;
  @Input() selectedAirport: IEngineParamChange<number | string>;
  @Input() onlyCustomHoliday: boolean;
  @Input() onlyNetQuotes: boolean;
  @Output() selectedDate = new EventEmitter<IEngineParamChange<NgbDateStruct>>();
  @Input() defaultDate: string;
  @Input() engineTabType: EngineTabTypes;

  selectedDateInternal: NgbDateStruct;
  loadingStatus: boolean;
  loadingMessage: string;

  dpModalRefSubscription: Subscription;

  private dpModalRef: NgbModalRef;

  constructor(private _modalService: NgbModal,
              private _holidayPrefetchService: HolidayPrefetchService,
              private _mobileService: MobileService,
              private _bookingService: BookingService,
              private _modalStatusService: ModalStatusService) {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.selectedDestination && this.selectedDestination?.resetParams) ||
      (changes.selectedAirport && this.selectedAirport?.resetParams)) {
      this.selectDate(undefined);
    }
    if (this.defaultDate) {
      const tmpDate = this.defaultDate.split('-').map(i => parseInt(i, 10));
      this.selectedDateInternal = new NgbDate(tmpDate[0], tmpDate[1], tmpDate[2]);
    }
  }

  selectDate(param: IEngineParamChange<NgbDateStruct>): void {
    this.selectedDateInternal = param?.value;
    this.selectedDate.emit(param);
  }

  open(): void {
    if (!this._modalService.hasOpenModals()) {
      this._modalStatusService.hasOpenModals.next(true);
      this.dpModalRef = this._modalService.open(EngineHolidayModalDatepickerComponent, {
        ariaLabelledBy: 'modal-engine', size: 'md'
      });
      this.dpModalRef.componentInstance.selectedDestination = this.selectedDestination;
      this.dpModalRef.componentInstance.engineTabType = this.engineTabType;
      this.dpModalRef.componentInstance.selectedAirport = this.selectedAirport;
      this.dpModalRef.componentInstance.onlyCustomHoliday = this.onlyCustomHoliday;
      this.dpModalRef.componentInstance.onlyNetQuotes = this.onlyNetQuotes;
      this.dpModalRef.componentInstance.defaultDate = this.defaultDate;
      setTimeout(() => {
        this.dpModalRefSubscription = this.dpModalRef.componentInstance.selectedDate.subscribe(e => {
          this.selectDate(e);
        });
      });
      this.dpModalRef.result.finally(() => this._modalStatusService.hasOpenModals.next(false));
    }
  }

  ngOnDestroy(): void {
    this.dpModalRefSubscription?.unsubscribe();
  }

}
